export default {
    state: {
        stores: [],
    },
    mutations: {},
    actions: {
        bindStores({ dispatch }) {
            return dispatch('bindCollection', 'stores')
        },

        unbindStore({ dispatch }) {
            return dispatch('unbindState', 'store')
        },

        async createStore({ dispatch }, data) {
            return await dispatch('createDocument', { collection: 'stores', data: data })
        },

        async getStore({ dispatch }, id) {
            return await dispatch('getDocument', { collection: 'stores', id: id })
        },

        async updateStore({ dispatch }, data) {
            return await dispatch('updateDocument', { collection: 'stores', data: data })
        },
    },
}
